<ion-content class="ion-padding">
  <div class="flex items-center justify-between mb-[10px]">
    <div class="w-[44px] h-[44px] flex justify-center items-center bg-[#FFF3E6] rounded-full">
      <span class="material-symbols-outlined text-[#E98F08]">receipt_long</span>
    </div>
  </div>

  <div class="text-[20px] font-[700]">{{ 'USER_PROFILE.PRIVACY.GCS' | translate }}</div>

  <div class="policy-html" [innerHTML]="policyHtml"></div>
</ion-content>

<ion-item lines="none" class="checkbox-item">
  <ion-checkbox
    slot="start"
    [(ngModel)]="accepted"
    (ngModelChange)="changAccepted($event)"
  ></ion-checkbox>
  <ion-label>{{ 'TERMS_POLICY_PAGE.I_AGREE_TO_GCS_POLICY' | translate }}</ion-label>
</ion-item>

@if (submitFailed) {
  <div class="ion-padding-horizontal text-sm" style="color: var(--ion-color-danger);">
    {{ 'TERMS_POLICY_PAGE.ACCEPT_FAILED' | translate }}
  </div>
}

<div class="ion-padding" (click)="onSubmit()">
  <ion-button [disabled]="!accepted || loading" class="w-full text-base">
    {{ 'BUTTONS.ACCEPT_CONTINUE' | translate }}
  </ion-button>
</div>

